import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Building2, Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) { setState("error"); setMsg("Link non valido."); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/verify-email", { token });
        if (data.user) setUser(data.user);
        setState("ok");
      } catch (e) {
        setState("error");
        const d = e?.response?.data?.detail;
        setMsg(typeof d === "string" ? d : "Link di verifica non valido o scaduto.");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md bg-card border border-border rounded-2xl p-8 text-center fade-in">
        <div className="h-11 w-11 rounded-md bg-[#007BFF] flex items-center justify-center mx-auto mb-6"><Building2 className="h-6 w-6 text-white" /></div>
        {state === "loading" && (
          <div data-testid="verify-loading" className="flex flex-col items-center gap-3 text-muted-foreground">
            <Loader2 className="h-8 w-8 animate-spin text-[#007BFF]" /><p>Verifica dell'email in corso…</p>
          </div>
        )}
        {state === "ok" && (
          <div data-testid="verify-success" className="flex flex-col items-center gap-3">
            <CheckCircle2 className="h-12 w-12 text-[#007BFF]" />
            <h1 className="font-head text-2xl font-bold">Email confermata!</h1>
            <p className="text-muted-foreground text-sm">Il tuo account è attivo. Sei già connesso.</p>
            <Button data-testid="verify-goto-dashboard" onClick={() => navigate("/")} className="mt-2 h-11 bg-[#007BFF] hover:bg-[#0056B3] text-white w-full">Vai alla dashboard</Button>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error" className="flex flex-col items-center gap-3">
            <XCircle className="h-12 w-12 text-red-500" />
            <h1 className="font-head text-2xl font-bold">Verifica non riuscita</h1>
            <p className="text-muted-foreground text-sm">{msg}</p>
            <Button data-testid="verify-goto-login" onClick={() => navigate("/login")} variant="outline" className="mt-2 h-11 w-full">Torna all'accesso</Button>
          </div>
        )}
      </div>
    </div>
  );
}
